//
// Validation config for italian regulations
// -----------------------------------------

define(function(require, exports, module) {
    'use strict';

    var userValidationConfig = require('modules/user/user.validation.config');

    var _ = require('underscore');
    var i18n = require('i18n');
    var checkCountry = function($inputs, config, form) {
        var select = form.el.querySelector('.fn-countryOfBirth select');
        var customData = form.options.data || [];
        var country = _.findWhere(customData, { 'code': select.value });
        var sameNameCountries = _.filter(customData, function(matchedCountry) {
            return country.regulationName === matchedCountry.regulationName;
        });

        var day = Number(form.data('day'));
        var month = Number(form.data('month'));
        var year = Number(form.data('year'));
        var dateOfBirth = Date.parse(new Date(year, month - 1, day));

        if (day && month && year) {
            return sameNameCountries.some(function(location) {
                return location.startDate <= dateOfBirth && dateOfBirth < location.endDate;
            });
        }

        return true;
    };

    module.exports = function() {
        var config = userValidationConfig();

        return _.extend({}, config, {
            countryOfBirth: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.country.required')
                },
                fn: {
                    fn: function($inputs, cfg, form) {
                        var $birthdateField = form.$el.find('.fn-birthdate');
                        var result = checkCountry.apply(this, arguments);

                        if (!result) {
                            form.setFieldInvalid($birthdateField, {
                                message: i18n.t('playtech.mobile.registration.countryOfBirth.check')
                            });
                        } else {
                            form.setFieldValid($birthdateField);
                        }

                        return result;
                    },
                    message: i18n.t('playtech.mobile.registration.countryOfBirth.check')
                }
            },
            italianBirthdate: {
                fn: {
                    fn: function($inputs, cfg, form, dfd, event, data) { // eslint-disable-line
                        var minAge = 18;
                        var currentDate = new Date();
                        var year = Number(form.data('year'));
                        var month = Number(form.data('month'));
                        var day = Number(form.data('day'));
                        var areAllInputsFilled = Boolean(day && month && year);
                        var $countryOfBirthField = form.$el.find('.fn-countryOfBirth');
                        var birthDate;
                        var adultDate;

                        if (areAllInputsFilled) {
                            birthDate = new Date(year, month - 1, day);
                            adultDate = new Date(birthDate.getFullYear() + minAge, birthDate.getMonth(), birthDate.getDate());
                        }

                        if (!areAllInputsFilled) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');
                            return false;
                        }

                        if (areAllInputsFilled && !checkCountry.apply(this, arguments)) {
                            this.message = i18n.t('playtech.mobile.registration.countryOfBirth.check');

                            form.setFieldInvalid($countryOfBirthField, {
                                message: i18n.t('playtech.mobile.registration.countryOfBirth.check')
                            });

                            return false;
                        }

                        form.setFieldValid($countryOfBirthField);

                        return adultDate <= currentDate;
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.birthdate.fn')
                }
            },
            personalId: {
                required: true,
                length: {
                    min: 16,
                    max: 16,
                    message: i18n.t('playtech.mobile.registration.personalId.tooltip.length')
                },
                regexp: {
                    regexp: /^[a-z0-9]{16}$/i,
                    message: i18n.t('playtech.mobile.registration.personalId.tooltip.regexp')
                }
            },
            provinceOfBirth: {
                fn: {
                    fn: function($inputs, cfg, form) {
                        return form.data('countryOfBirth') === 'IT' ? Boolean($inputs.val()) : true;
                    },
                    message: i18n.t('playtech.mobile.system.tooltip.required')
                }
            },
            citizenship: {
                required: true
            },
            province: {
                required: true
            },
            cityList: {
                fn: {
                    fn: function($inputs, cfg, form) {
                        return form.data('countryOfBirth') === 'IT' ? Boolean($inputs.val()) : true;
                    },
                    message: i18n.t('playtech.mobile.system.tooltip.required')
                }
            },
            cityOfCitizenship: {
                fn: {
                    fn: function($inputs) {
                        return Boolean($inputs.val());
                    },
                    message: i18n.t('playtech.mobile.system.tooltip.required')
                }
            },
            zip: _.extend(config.zip, {
                length: {
                    min: 5,
                    max: 5,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.length.italian')
                }
            }),
            idType: {
                required: true
            },
            idNumber: {
                required: true,
                regexp: {
                    regexp: /^[a-z0-9]+$/i,
                    message: i18n.t('playtech.mobile.registration.idNumber.tooltip.regexp')
                }
            },
            idIssueDate: {
                required: true,
                fn: {
                    fn: function($inputs, cfg, form, dfd, event, data) {
                        var day = Number(form.data('day'));
                        var month = Number(form.data('month'));
                        var year = Number(form.data('year'));

                        var birthDate = data.birthdate.split('-');
                        var parsedBirthDate = Date.parse(new Date(birthDate));
                        var idIssueDate = Date.parse(new Date(year, month - 1, day));

                        if (idIssueDate < parsedBirthDate) {
                            this.message = i18n.t('playtech.mobile.registration.user.idIssueDate2.fn');
                            return false;
                        } else if (idIssueDate >= Date.now()) {
                            this.message = i18n.t('playtech.mobile.registration.user.idIssueDate.fn');
                            return false;
                        }

                        return true;
                    },
                    message: i18n.t('playtech.mobile.registration.user.idIssueDate.fn')
                }
            },
            idIssuer: {
                required: true
            },
            issuePlace: {
                required: true
            },
            contract: {
                required: true
            },
            privacy: {
                required: true
            },
            adult: {
                required: true
            }
        });
    };
});
